import { c as _c } from "react/compiler-runtime";
import { useInfoChips } from "@website/ui/info-chips/info-chips.hook";
import styles from "@website/ui/info-chips/info-chips.module.scss";
import { InfoChipsPropertiesType } from "@website/ui/info-chips/info-chips.types";
import { Loading } from "@website/ui/loading";
import { FC } from "react";
export const InfoChips: FC<InfoChipsPropertiesType> = properties => {
  const $ = _c(10);
  const {
    children,
    className,
    color: t0,
    EndIcon,
    loading,
    size: t1,
    StartIcon,
    variant: t2,
    text
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const size = t1 === undefined ? "small" : t1;
  const variant = t2 === undefined ? "contained" : t2;
  const {
    infoChipsProps
  } = useInfoChips(properties);
  const classNames = `${styles["info-chips"]} ${styles[variant]} ${styles[color]} ${styles[size]} ${styles[`icon-${size}`]} ${className ?? ""}`;
  let t3;
  if ($[0] !== EndIcon || $[1] !== StartIcon || $[2] !== children || $[3] !== loading || $[4] !== text) {
    t3 = loading ? <Loading color="white" size="sm" /> : <>{StartIcon ? <span className={styles.icon}>{StartIcon}</span> : null}{text ? <span className={styles.text}>{text}</span> : null}{children ? <span className={styles.children}>{children}</span> : null}{EndIcon ? <span className={styles.icon}>{EndIcon}</span> : null}</>;
    $[0] = EndIcon;
    $[1] = StartIcon;
    $[2] = children;
    $[3] = loading;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const elements = t3;
  let t4;
  if ($[6] !== classNames || $[7] !== elements || $[8] !== infoChipsProps) {
    t4 = <div {...infoChipsProps} className={classNames}>{elements}</div>;
    $[6] = classNames;
    $[7] = elements;
    $[8] = infoChipsProps;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};